import { RedirectLoginOptions } from '@auth0/auth0-react';
import { signupParamsFromUrl } from '@grc/ui-utility';

// Query params never carried back to the page after login:
// - the invite email's screen_hint/login_hint, which Auth0 reads on the login they start, so the
//   invited email does not stay in the address bar and a later login opens the login form;
// - Auth0's own callback params, left in the URL when a callback fails. Carried back, a reload
//   would replay the spent callback and fail with "Invalid state".
const PARAMS_NOT_RETURNED_TO = [
  'screen_hint',
  'login_hint',
  'code',
  'state',
  'error',
  'error_description'
];

// The page to return to after login must be a path on this origin. A path like //evil.com/x or
// /\evil.com/x (browsers read \ as /) names another host, and navigating to it would leave the
// site right after a real login, so anything else returns to the root instead.
export const safeReturnTo = (returnTo: unknown): string => {
  if (
    typeof returnTo !== 'string' ||
    returnTo[0] !== '/' ||
    returnTo[1] === '/' ||
    returnTo[1] === '\\'
  ) {
    return '/';
  }
  // The URL parser also drops tabs and newlines, so /<tab>/evil.com still resolves off-site.
  const { origin } = window.location;
  return new URL(returnTo, origin).origin === origin ? returnTo : '/';
};

const currentPageToReturnTo = () => {
  const url = new URL(window.location.href);
  PARAMS_NOT_RETURNED_TO.forEach(name => url.searchParams.delete(name));
  return safeReturnTo(url.pathname + url.search + url.hash);
};

// An invite link opens Auth0 Register with the invited email filled in, and after login
// Auth0ProviderWithRedirectCallback navigates back to appState.returnTo, the page the user was on.
export const loginOptions = (): RedirectLoginOptions => ({
  authorizationParams: signupParamsFromUrl(),
  appState: { returnTo: currentPageToReturnTo() }
});
